module.exports = __webpack_public_path__ + "static/sylacaugahh-d99acf9dec239f8f4e4214bd0ef09198.jpg";